export const oneOf = (...args) => {
  for (const arg of args) {
    if (arg !== undefined) {
      return arg;
    }
  }

  return args[args.length - 1];
};
